module.exports = __webpack_public_path__ + "img/linkedin-logo.fc0990b.png";